'use client';

import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import SpaIcon from '@mui/icons-material/Spa';

const steps = [
  {
    icon: <TouchAppIcon sx={{ fontSize: 48, color: '#fbbf24' }} />,
    title: 'Choose Your Beauty Service',
    button: 'Book Now and Enjoy a Long Experience',
  },
  {
    icon: <AccessTimeIcon sx={{ fontSize: 48, color: '#fbbf24' }} />,
    title: 'Pick Date & Time',
    button: 'Schedule Your Appointment Easily',
  },
  {
    icon: <CheckCircleOutlineIcon sx={{ fontSize: 48, color: '#fbbf24' }} />,
    title: 'Confirm Your Booking',
    button: 'Confirm & Continue Booking Process',
  },
  {
    icon: <SpaIcon sx={{ fontSize: 48, color: '#fbbf24' }} />,
    title: 'Get Ready for Your Session',
    button: 'Prepare Yourself Comfortably at Home',
  },
  {
    icon: <PersonOutlineIcon sx={{ fontSize: 48, color: '#fbbf24' }} />,
    title: 'Enjoy Beauty at Your Doorstep',
    button: 'Relax and Enjoy Our Premium Service',
  },
];

export default function BookingCards() {
  return (
    <section
      className="relative py-12 text-center overflow-hidden bg-transparent mt-0 lg:mt-[-140px] mb-[-30px]"
    >
      {/* Section Title */}
      <h2 className="text-2xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-16 px-4 md:px-0">
        Book Your{' '}
        <span className="text-pink-600 underline underline-offset-4">amazing</span>{' '}
        beauty service at home in just a few steps
      </h2>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 max-w-7xl mx-auto" style={{marginTop:'45px'}}>
        {steps.map((step, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md flex flex-col justify-start items-center cursor-pointer hover:shadow-xl transition-shadow duration-300 p-6 min-h-[220px]"
          >
            {/* Icon */}
            <div className="flex items-center justify-center mb-4 h-12">{step.icon}</div>

            {/* Button */}
            <button
              className="text-center font-bold text-gray-800 text-base sm:text-lg md:text-xl lg:text-2xl w-full break-words mb-4 App-button px-4 py-2 transition-colors duration-200 focus:outline-none focus:ring-0"
              style={{
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                textAlign: 'center',
                marginTop: '6px',
                color: 'black',
                fontWeight: '700'
              }}
            >
              {step.button}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
